const { getAutocompleteResults, getLegacyAutocompleteResults, getHighlightAutocompleteResults, getItemHyperlink } = require('../../util/family_autocomplete_search_util.js');

/**
 * A service used to retrieve family matches from the backend.
 * @ngInject
 * @deprecated Use the family_autocomplete_search_util.js file instead
 */
function FamilyAutocompleteSearchService() {
  return {
    /**
     * Get a list of family matches.
     *
     * @param {String} query
     * @return {Promise}
     */
    get: getAutocompleteResults,

    getLegacyAutocompleteResults: getLegacyAutocompleteResults,

    getHighlightAutocompleteResults: getHighlightAutocompleteResults,
    /**
     * Returns hyperlink for the result item
     * @param resultItem
     * @returns {string}
     */
    getItemHyperlink: getItemHyperlink
  };
}

module.exports = FamilyAutocompleteSearchService;
